/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import poaAttorneyHeaderStyle from "./poaAttorneyHeaderStyle";
import FrankRiedelImage from "../../../../assets/img/jobs/frankriedel.jpg";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

type PoaAttorneyHeaderProps = {
  product: "divorce" | "settlement";
};

const PoaAttorneyHeader = ({ product }: PoaAttorneyHeaderProps) => {
  return (
    <Grid container sx={poaAttorneyHeaderStyle.headerContainer} spacing={2}>
      <Grid item sm={2} xs={12}>
        <Paper elevation={4} sx={poaAttorneyHeaderStyle.imageCircleContainer}>
          <img src={FrankRiedelImage} alt={"Rechtsanwalt Frank Riedel"} />
        </Paper>
      </Grid>
      <Grid item sm={10} xs={12} sx={poaAttorneyHeaderStyle.text}>
        {product === "divorce" && (
          <>
            Unser Rechtsanwalt Frank Riedel benötigt nun noch Ihre Vollmacht, damit er Sie vertreten darf und mit der Erstellung Ihres Scheidungsantrags
            beginnen kann. Frank Riedel ist ein erfahrener Fachanwalt für Familienrecht. Er begleitet Sie professionell bei Ihrer Scheidung und ist bei allen
            rechtlichen Fragen für Sie da!
          </>
        )}
        {product === "settlement" && (
          <>
            Unser Anwalts-Team rund um Rechtsanwalt Frank Riedel benötigt nun noch Ihre Vollmacht, damit Ihre Kündigung kostenlos geprüft werden kann und wir
            Sie im Anschluss, wenn von Ihnen gewünscht, rechtlich vertreten dürfen. Frank Riedel ist ein erfahrener Anwalt für Arbeitsrecht. Er begleitet Sie
            gemeinsam mit seinem Team und ist bei allen rechtlichen Fragen für Sie da!
          </>
        )}
      </Grid>
      <Grid item xs={12} sx={poaAttorneyHeaderStyle.text}>
        <p>
          {product === "divorce" && <>Die Höhe der Scheidungskosten kann, basierend auf Ihren Angaben, wie folgt geschätzt werden:</>}
          {product === "settlement" && (
            <>Die Höhe Ihrer Abfindung und die damit verbundenen Kosten können aufgrund Ihrer Angaben wie folgt eingeschätzt werden:</>
          )}
        </p>
      </Grid>
    </Grid>
  );
};

// @ts-ignore
export default PoaAttorneyHeader;
